import { createSlice, PayloadAction, CaseReducer } from '@reduxjs/toolkit';

import { Toast } from '@10d/tend-ui/primitives/Toast';

import { get, post } from 'api/requests';

import { IReducer, AppThunk } from 'store/types';
import { IParamsReq } from 'types';
import {
  TimeTableState,
  TimeTableEmployee,
  TimeTableData,
  ProjectsTimeTable,
} from 'pages/TimeTable/TimeTableApartments/types';

const initialState: TimeTableState = {
  loading: false,
  loadingEdit: false,
  // @ts-ignore TODO TS err
  editData: [],
  // @ts-ignore TODO TS err
  data: [],
};

const reset: IReducer<TimeTableState, TimeTableState> = () => initialState;

const setTimeTable: CaseReducer<TimeTableState, PayloadAction<TimeTableData>> = (state, action) => {
  state.data = action.payload;
};

const setEditData: CaseReducer<TimeTableState, PayloadAction<ProjectsTimeTable>> = (
  state,
  action,
) => {
  state.editData = action.payload;
};

const loading: CaseReducer<TimeTableState, PayloadAction<boolean>> = (state, action) => {
  state.loading = action.payload;
};

const loadingEdit: CaseReducer<TimeTableState, PayloadAction<boolean>> = (state, action) => {
  state.loadingEdit = action.payload;
};

export const timeTableSlice = createSlice({
  name: 'timeTable',
  initialState,
  reducers: {
    loading,
    loadingEdit,
    setTimeTable,
    setEditData,
    reset,
  },
});

const {
  loading: setLoading,
  loadingEdit: setLoadingEdit,
  setTimeTable: setTimeTableData,
  setEditData: setEditTimeTableData,
  reset: setReset,
} = timeTableSlice.actions;

export const getTimeTable =
  (isProjects: boolean, search: IParamsReq): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));

    get<TimeTableData>(
      `/api/timesheet/schedule/work_days/by_${isProjects ? 'project' : 'employee'}/`,
      search,
    )
      .then(({ data }) => {
        dispatch(setTimeTableData(data));
      })
      .finally(() => dispatch(setLoading(false)));
  };

/* TODO dispatch */
export const setNewTimeTable =
  (startDate: string, endDate: string, project: number, workDays: TimeTableEmployee[]): AppThunk =>
  () => {
    post('/api/timesheet/schedule/multi_create/', {
      startDate: startDate,
      endDate: endDate,
      project,
      workDays,
    }).then(() => Toast.success({ message: 'Расписание добавлено' }));
  };

export const getEditTimeTable =
  (date: string): AppThunk =>
  dispatch => {
    get<ProjectsTimeTable>('/api/timesheet/schedule/work_day/by_project/', {
      date,
    })
      .then(({ data }) => {
        dispatch(setEditTimeTableData(data));
      })
      .finally(() => dispatch(setLoadingEdit(false)));
  };

export const editTimeTable =
  (date: string, workDays: number[]): AppThunk =>
  dispatch => {
    dispatch(setLoadingEdit(true));

    post('/api/timesheet/schedule/work_days/multi_delete/', {
      workDays,
    }).then(() => {
      dispatch(getEditTimeTable(date));
    });
  };

export const resetEditTimeTable = (): AppThunk => dispatch => {
  // @ts-ignore TODO TS err
  dispatch(setEditTimeTableData([]));
};

export const resetTableData = (): AppThunk => dispatch => {
  // @ts-ignore TODO TS err
  dispatch(setReset([]));
};

export { setLoading };
